<template>
 <svg :style="style" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="&#230;&#150;&#185;&#229;&#188;&#143;=&#228;&#189;&#143;&#233;&#153;&#162;&#233;&#154;&#143;&#232;&#174;&#191;, &#230;&#152;&#175;&#229;&#144;&#166;&#228;&#184;&#186;&#230;&#181;&#133;&#232;&#137;&#178;=on">
<g id="Frame" clip-path="url(#clip0_4386_91493)">
<path id="Vector" d="M12.6667 5.08333H10.3333V3.33333C10.3329 2.71464 10.0869 2.12143 9.64938 1.68395C9.2119 1.24647 8.61869 1.00048 8 1H3.33333C2.71464 1.00048 2.12143 1.24647 1.68395 1.68395C1.24647 2.12143 1.00048 2.71464 1 3.33333V12.6667C1.00048 13.2854 1.24647 13.8786 1.68395 14.316C2.12143 14.7535 2.71464 14.9995 3.33333 15H12.6667C13.2854 14.9995 13.8786 14.7535 14.316 14.316C14.7535 13.8786 14.9995 13.2854 15 12.6667V7.41667C14.9995 6.79798 14.7535 6.20476 14.316 5.76728C13.8786 5.3298 13.2854 5.08382 12.6667 5.08333ZM3.91667 13.8333V9.75C3.91715 9.44073 4.04022 9.14426 4.25891 8.92557C4.4776 8.70689 4.77406 8.58382 5.08333 8.58333H6.25C6.55927 8.58382 6.85574 8.70689 7.07443 8.92557C7.29311 9.14426 7.41618 9.44073 7.41667 9.75V13.8333H3.91667ZM4.5 5.66667C4.34529 5.66667 4.19692 5.60521 4.08752 5.49581C3.97812 5.38642 3.91667 5.23804 3.91667 5.08333C3.91667 4.92862 3.97812 4.78025 4.08752 4.67085C4.19692 4.56146 4.34529 4.5 4.5 4.5H5.08333V3.91667C5.08333 3.76196 5.14479 3.61358 5.25419 3.50419C5.36358 3.39479 5.51196 3.33333 5.66667 3.33333C5.82138 3.33333 5.96975 3.39479 6.07915 3.50419C6.18854 3.61358 6.25 3.76196 6.25 3.91667V4.5H6.83333C6.98804 4.5 7.13642 4.56146 7.24581 4.67085C7.35521 4.78025 7.41667 4.92862 7.41667 5.08333C7.41667 5.23804 7.35521 5.38642 7.24581 5.49581C7.13642 5.60521 6.98804 5.66667 6.83333 5.66667H6.25V6.25C6.25 6.40471 6.18854 6.55308 6.07915 6.66248C5.96975 6.77187 5.82138 6.83333 5.66667 6.83333C5.51196 6.83333 5.36358 6.77187 5.25419 6.66248C5.14479 6.55308 5.08333 6.40471 5.08333 6.25V5.66667H4.5ZM11.7917 12.0833C11.637 12.0833 11.4886 12.0219 11.3792 11.9125C11.2698 11.8031 11.2083 11.6547 11.2083 11.5C11.2083 11.3453 11.2698 11.1969 11.3792 11.0875C11.4886 10.9781 11.637 10.9167 11.7917 10.9167H12.375C12.5297 10.9167 12.6781 10.9781 12.7875 11.0875C12.8969 11.1969 12.9583 11.3453 12.9583 11.5C12.9583 11.6547 12.8969 11.8031 12.7875 11.9125C12.6781 12.0219 12.5297 12.0833 12.375 12.0833H11.7917ZM12.375 9.16667H11.7917C11.637 9.16667 11.4886 9.10521 11.3792 8.99581C11.2698 8.88642 11.2083 8.73804 11.2083 8.58333C11.2083 8.42862 11.2698 8.28025 11.3792 8.17085C11.4886 8.06146 11.637 8 11.7917 8H12.375C12.5297 8 12.6781 8.06146 12.7875 8.17085C12.8969 8.28025 12.9583 8.42862 12.9583 8.58333C12.9583 8.73804 12.8969 8.88642 12.7875 8.99581C12.6781 9.10521 12.5297 9.16667 12.375 9.16667Z" fill="#D2D5D9"/>
</g>
</g>
<defs>
<clipPath id="clip0_4386_91493">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>






</template>

<script>
export default {
  name: 'icon-in-hospital-black',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>